import * as React from 'react';
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
import {TabPanel} from "../../../components/other/tabPanel";
import {StyledTabs, StyledTab} from "../admin";
import {Button, FormControlLabel, Switch} from "@mui/material";
import {AgyleNamedIcon} from '../../../components/icons/agyle';
import AttendancesComponent from './attendanceComponent';


const useStyles = makeStyles((theme) => ({
    indicator: {
        backgroundColor: "#448FFF"
    },
    switch_base: {
        "&.Mui-checked": {
            color: "#448FFF"
        },
        "&.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "#448FFF",
        }
    },
}));

function AttendancesManagment(props) {
    const [tab, setTab] = React.useState(0);
    const classes = useStyles();
    const attCompRef = React.useRef(null);

    const handleChange = (event, newValue) => {
        setTab(newValue);
    };

    const [filterHidden, setFiltersHidden] = React.useState(false);

    const handleHideFilters = (e) => {
        setFiltersHidden(e.target.checked);
        e.stopPropagation();
    }

    const [liveMessage, setLiveMessage] = React.useState(false);

    const handleLive = (e) => {
        setLiveMessage(e.target.checked);
        e.stopPropagation();
    }
    const exportCsv = (event) => {
        // if(tab==0) {
        //     attCompRef.current.exportCsv();
        // }
    }
    const switchVisible = () => {
        return tab === 0 || tab === 1 || tab === 2;
    }
    return (<Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',display: 'flex', justifyContent: 'space-between', paddingRight: "25px" }}>
            <StyledTabs value={tab} onChange={handleChange} aria-label="Report labels" TabIndicatorProps={{className: classes.indicator}}>
                <StyledTab value={0} label="ED Closure" />
            </StyledTabs>
            {switchVisible() &&
            <div style={{display: "inline-flex", alignItems: "center"}}>
                <div style={{display: "flex"}}>
                    <FormControlLabel label={"Hide Filters "} control={
                        <Switch classes={{switchBase: classes.switch_base}} checked={filterHidden} size="small" onChange={handleHideFilters}/>}
                    />
                    <FormControlLabel label={"Live Message"} control={
                        <Switch classes={{switchBase: classes.switch_base}} checked={liveMessage} size="small" onChange={handleLive}/>}
                    />
                </div>
            </div>
            }

        </Box>
        <TabPanel value={tab} index={0}>
            <AttendancesComponent filterHidden = {filterHidden} liveMessage={liveMessage} ref={attCompRef}/>
        </TabPanel>
    </Box>)
}

export default AttendancesManagment;